<template>
  <div id="app" class="flex flex-col h-screen">
    <HFooter></HFooter>
    <Navbar v-if="isLogin"></Navbar>
    <div class="flex-grow py-4">
      <router-view />
    </div>
    <Footer v-if="isLogin"></Footer>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
import HFooter from "vue-hacktiv-footer";
import { mapState } from 'vuex';

export default {
  name: "App",
  components: {
    Navbar,
    Footer,
    HFooter,
  },
  computed: {
    ...mapState(['isLogin'])
  },
  created() {
    if (localStorage.access_token) {
      this.$store.dispatch("setLogin", true);
    }
  },
};
</script>

<style>
</style>
